/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import { ArrowRight } from "@/components/Svg";
import BlockBtn from "@/components/main/form/btn/BlockBtn";
import {
  Text,
  Title,
  CloseButton,
  Modal,
  useMantineTheme,
} from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import Link from "next/link";
import { usePathname } from "next/navigation";

function SignInModal({ show, setShow, dictionary }) {
  const pathname = usePathname();
  const theme = useMantineTheme();
  return (
    <>
      <Modal
        centered
        overlayProps={{ blur: 5 }}
        lockScroll={true}
        opened={show}
        onClose={() => {
          setShow(false);
        }}
        // size={"lg"}
        withCloseButton={false}
        padding={0}
        radius={"lg"}
      >
        <div className=" min-h-fit flex flex-col justify-between">
          <div
            className="flex justify-center p-6 rounded-t-lg relative"
            style={{
              backgroundColor: theme.fn.rgba(theme.colors["red"][3], 0.1),
            }}
          >
            <IconAlertCircle size={100} className=" text-red-500" />
            <CloseButton
              size={"md"}
              className=" absolute top-4 right-4"
              onClick={() => {
                setShow(false);
              }}
            />
          </div>
        </div>

        <div className="p py-5 px-8 h-full w-full flex justify-center items-center">
          <div className="flex flex-col justify-center w-full px-5">
            <div className="flex justify-center">
              <div className="w-full sm:w-96">
                <Title
                  order={3}
                  className="text-grayCustom text-center"
                  color
                  size={22}
                >
                  {dictionary.youAreNotLoggedIn}
                </Title>
                <Text className="text-textGrey mb-5 text-center" color>
                  {dictionary.loginToContinue}
                </Text>
                <Link
                  href={`/signin?callback=${pathname}`}
                  className="no-underline"
                >
                  <BlockBtn rightIcon={<ArrowRight />}>
                    {dictionary.goToLoginPage}
                  </BlockBtn>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SignInModal;
